import { connect } from 'react-redux';

import ChatDetailsPanel from './';
import { leaveChannel } from '../../actions/chatActions';
import { updateModal, closeModal } from '../../actions/modalActions';

const mapStateToProps = (state, ownProps) => {
  const chatId = ownProps.match.params.chatId;
  const chat = state.chats[chatId];
  return {
    chatId,
    chat,
    users: state.users,
    identityId: state.identity.id,
  };
};

const mapDispatchToProps = dispatch => ({
  leaveChannel: chatId => dispatch(leaveChannel(chatId)),
  updateModal: content => dispatch(updateModal(content)),
  hideModal: () => dispatch(closeModal()),
});


export default connect(mapStateToProps, mapDispatchToProps)(ChatDetailsPanel);
